var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"title":"关联客户","visible":_vm.visible,"width":800,"confirmLoading":_vm.loading},on:{"cancel":_vm.cancel,"ok":_vm.ok}},[_c('ml-table',{attrs:{"columns":_vm.columns,"dataSource":_vm.dataSource,"size":"small","rowKey":"id","pagination":_vm.pagination,"scroll":{ y: 400 },"rowSelection":{
      selectedRowKeys: _vm.selectedRowKeys,
      onChange: _vm.onSelectChange
    }},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }